import React from 'react'
import * as ol from 'ol'
export interface mapCtx {
  map: ol.Map
}
const MapContext: React.Context<any | null | mapCtx> = React.createContext(null)
export default MapContext
